// config/config.js
// const BASE_URL = "http://109.205.179.181/api";
const BASE_URL = "/api";
// const BASE_URL = "http://localhost:5000/api";

//const BASE_URL = "https://avstore.lk/api";

// const BASE_URL = "https://avstore.lk/api";


module.exports = {
  BASE_URL,
  EMAILJS_SERVICE_ID: 'service_y3yje7i',
  EMAILJS_TEMPLATE_ID: 'template_98stugb',
  EMAILJS_PUBLIC_KEY: '2PtarFMcBdTqcVtM5',
};
